import {
  Action,
  ActionType,
  IContractInformationResponse,
} from "models/contract/information";
import createReducer from "../../createReducer";

export interface ContractInformationReducerType {
  loading: boolean;
  error?: string;
  contractInformationResponse?: IContractInformationResponse;
}

const defaultState: ContractInformationReducerType = {
  loading: false,
  error: undefined,
  contractInformationResponse: undefined,
};

export const contractInformationReducer =
  createReducer<ContractInformationReducerType>(defaultState, {
    [ActionType.CONTRACT_INFORMATION](state: ContractInformationReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CONTRACT_INFORMATION_ERROR](
      state: ContractInformationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.CONTRACT_INFORMATION_SUCCESS](
      state: ContractInformationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        contractInformationResponse: action.payload,
      };
    },
  });
